'use client'

import { Avatar, Button, Icon, IconComponent } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import { getInitials } from '@common/components/Sidebar/Sidebar.helpers'
import { getSafeImageUrl } from '@common/helpers'

import { useMobileMenuContext } from '../../context'

import styles from '../../MobileMenu.module.scss'

export function ProjectsView() {
  const {
    currentProject,
    mobileMenuProjects,
    navigateToMain,
    onClose,
    onCreateProject,
    onInviteProjectClick,
    onOpenProjectMembers,
    onOpenProjectSettings,
    onProjectClick,
  } = useMobileMenuContext()

  const currentProjectId = currentProject?.projectId

  const handleSettingsClick = () => {
    onOpenProjectSettings?.()
    onClose()
  }

  const handleMembersClick = () => {
    onOpenProjectMembers?.()
    onClose()
  }

  const handleInviteClick = () => {
    onInviteProjectClick?.()
    onClose()
  }

  const handleCreateProjectClick = () => {
    onCreateProject?.()
    onClose()
  }

  return (
    <div className={styles.menuView} data-testid={MOBILE_MENU_TEST_IDS.projectsView}>
      <div className={styles.header}>
        <button className={styles.backButton} onClick={navigateToMain}>
          <IconComponent icon={Icon.ChevronLeftRegular} size={24} />
          <span>Select Project</span>
        </button>
        <div className={styles.headerActions}>
          <Button iconOnly size="l" variant="ghost" icon={Icon.DismissRegular} onClick={onClose} />
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.submenuSection}>
          <div className={styles.submenuGroup}>
            <button
              className={`${styles.submenuItem} ${!onOpenProjectSettings ? styles.disabled : ''}`}
              onClick={handleSettingsClick}
              disabled={!onOpenProjectSettings}
            >
              <IconComponent icon={Icon.SettingsRegular} size={20} />
              <span>Settings</span>
            </button>
            <button
              className={`${styles.submenuItem} ${!onOpenProjectMembers ? styles.disabled : ''}`}
              onClick={handleMembersClick}
              disabled={!onOpenProjectMembers}
            >
              <IconComponent icon={Icon.PeopleRegular} size={20} />
              <span>Project members</span>
            </button>
            <button
              className={`${styles.submenuItem} ${!onInviteProjectClick ? styles.disabled : ''}`}
              onClick={handleInviteClick}
              disabled={!onInviteProjectClick}
            >
              <IconComponent icon={Icon.PeopleAddRegular} size={20} />
              <span>Invite people</span>
            </button>
          </div>

          <div className={styles.submenuSeparator} />

          <div className={styles.submenuGroup}>
            <div className={styles.submenuGroupLabel}>Switch project</div>
            {mobileMenuProjects.map((project) => {
              const isSelected = currentProjectId === project.projectId
              const initials = getInitials(project.name)
              return (
                <button
                  key={project.projectId}
                  className={`${styles.submenuItem} ${isSelected ? styles.selected : ''}`}
                  onClick={() => onProjectClick?.(project.projectId)}
                >
                  <div>
                    <Avatar size={20} src={getSafeImageUrl(project.logoUrl)} fallback={initials} />
                  </div>
                  <span>{project.name}</span>
                  {isSelected ? (
                    <IconComponent icon={Icon.CheckmarkRegular} size={20} className={styles.checkmark} />
                  ) : null}
                </button>
              )
            })}
          </div>

          <div className={styles.submenuSeparator} />

          <div className={styles.submenuGroup}>
            <button
              className={`${styles.submenuItem} ${!onCreateProject ? styles.disabled : ''}`}
              onClick={handleCreateProjectClick}
              disabled={!onCreateProject}
            >
              <IconComponent icon={Icon.AddRegular} size={20} />
              <span>Create project</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
